module.exports = __webpack_public_path__ + "img/03-AppMovizz-02.1024d1d9.png";